module.exports = __webpack_public_path__ + "static/img/Group 354.afa1e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Group 354.png
// module id = 7ELq
// module chunks = 13